const fieldTypes = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  EMAIL: 'EMAIL',
  TEXT_AREA: 'TEXT_AREA',
  SELECT: 'SELECT',
  CHECKBOX_GROUP: 'CHECKBOX_GROUP',
  RADIO_BUTTON_GROUP: 'RADIO_BUTTON_GROUP',
  FILE: 'FILE'
};

export default fieldTypes;